import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { collectionsByType } from '../../../redux/selectors/collections';
import { collectionsGroupType } from '../../common/types';
import pageWrapper from '../../containers/MainPage';
import ItemPreview from '../../common/ItemPreview';
import { changeCatSplit } from '../../../redux/ducks/collections';
import SliderGalleryItem from '../../../models/SliderGalleryItem';
import CollectionFilterSwitcher from './CollectionFilterSwitcher';
import splitAttrs from '../../../config/defaultSplitAttributes';
import { convertType } from '../../../config/constants';

class SearchItemPage extends React.PureComponent {
  componentDidMount() {
  }

  render() {
    const {
      match: {
        params: { searchTerm },
      },
      collections,
      hasAnyItemsInCollection,
    } = this.props;

    if (!searchTerm) {
      return (
        <div className="columns is-centered">
          <div
            className="column is-half notification is-info has-text-centered"
            style={{ marginTop: '20%' }}
          >
            <h5 className="title is-5">Please enter a value to search for. </h5>
          </div>
        </div>
      );
    }

    if (!hasAnyItemsInCollection) {
      return (
        <div className="columns is-centered">
          <div
            className="column is-half notification is-info has-text-centered"
            style={{ marginTop: '20%' }}
          >
            <h5 className="title is-5">You don&apos;t have any items in your collection yet. </h5>
            <p>
              <Link to="/collections/add" className="button is-inverted is-medium">
                Add your first one now.
              </Link>
            </p>
          </div>
        </div>
      );
    }

    const matchingItems = [];

    const searchTermLower = String(searchTerm).toLowerCase();

    // flatten the objects and the iterate over items
    _.map(collections, (collectionCat) => {
      _.map(collectionCat, (collection) => {
        collection.forEach((item) => {
          // apparently it is faster to us for...in loop - this exits early so should be fine anyway
          // eslint-disable-next-line no-restricted-syntax, guard-for-in
          for (const property in item.specificData) {
            const exists = item.specificData[property];
            const sValue = String(item.specificData[property]).toLowerCase();

            if (exists && sValue !== '' && sValue.indexOf(searchTermLower) > -1) {
              matchingItems.push(item);
              break;
            }
          }
        });
      });
    });

    return (

      <div>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <CollectionFilterSwitcher />
            </div>
          </div>
        </div>

        <h3 className="title is-4" style={{ marginBottom: 0 }}>
          Search Results for &quot;{searchTerm}&quot;
        </h3>
        {matchingItems.map(item => (
          <ItemPreview
            item={SliderGalleryItem.ItemFromGenericItemModel(
              item,
              item.category,
              splitAttrs[convertType(item.category)],
              item.specificData[splitAttrs[convertType(item.category)]],
            )}
            key={item.id}
          />
        ))}
      </div>
    );
  }
}

SearchItemPage.propTypes = {
  collections: collectionsGroupType,
  hasAnyItemsInCollection: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    shape: PropTypes.shape({
      category: PropTypes.string,
    }),
  }).isRequired,
};

SearchItemPage.defaultProps = {
  collections: [],
};

function mapStateToProps(state) {
  const {
    collections: { catSplitAttributes },
  } = state;

  const hasAnyItemsInCollection = state.collections.items.length > 0;

  return {
    collections: collectionsByType(state),
    catSplitAttributes,
    hasAnyItemsInCollection,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSplitAttribute: (category, newAttr) => {
      dispatch(changeCatSplit(category, newAttr));
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(SearchItemPage),
  'Search Results'
);



// WEBPACK FOOTER //
// ./src/components/pages/collections/SearchItemPage.jsx